webpackJsonp([163572868828437],{

/***/ 1573:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TravelZoneInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"color","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-travel-zone-input-d63cadbd77dd11e5ef4b.js